const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Migrate nodes', () => {
  describe('preview migrating a partial node tree', () => {
    const mock = loadRecordedMock('migrate_nodes_partial_preview.json');

    it(`should return a node migration preview`, (done) => {
      migratortronApi.post(
        'migrate/nodes?partial',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(new Error(body.error.message));

          expect(body?.nodes?.migratortron?.totalCount).to.equal(2);
          done();
        }
      );
    });
  });

  describe('migrate a partial node tree', () => {
    const mock = loadRecordedMock('migrate_nodes_commit_partial.json');

    it(`should create the nodes and return the results`, (done) => {
      migratortronApi.post(
        'migrate/nodes/commit?partial',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(new Error(body.error.message));

          expect(body?.nodes?.migratortron?.totalCount).to.equal(2);
          expect(body?.nodesResult.errors).to.not.exist;
          expect(body?.nodesResult.created).to.equal(3);
          expect(body?.nodesResult.updated).to.equal(0);
          done();
        }
      );
    });
  });

  describe('repeat the same migrate a partial node tree', () => {
    const mock = loadRecordedMock('migrate_nodes_commit_partial_repeat.json');

    it(`should return a node migration preview with no changes to perform`, (done) => {
      migratortronApi.post(
        'migrate/nodes/commit?partial&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(new Error(body.error.message));

          expect(jpath('nodesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.nodesResult.errors).to.not.exist;
          expect(body?.nodesResult.created).to.equal(0);
          expect(body?.nodesResult.updated).to.equal(0);
          done();
        }
      );
    });
  });

  describe("preview migrating a project's node tree", () => {
    const mock = loadRecordedMock('migrate_nodes_simple_preview.json');

    it(`should return a node migration preview`, (done) => {
      migratortronApi.post(
        'migrate/nodes?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(new Error(body.error.message));

          expect(body?.nodes?.migratortron?.totalCount).to.equal(6);
          done();
        }
      );
    });
  });

  describe("migrate a project's node tree", () => {
    const mock = loadRecordedMock('migrate_nodes_commit_simple.json');

    it(`should create the nodes and return the results`, (done) => {
      migratortronApi.post(
        'migrate/nodes/commit?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(new Error(body.error.message));

          expect(body?.nodes?.migratortron?.totalCount).to.equal(6);
          expect(body?.nodesResult.errors).to.not.exist;
          expect(body?.nodesResult.created).to.equal(2);
          expect(body?.nodesResult.updated).to.equal(0);
          done();
        }
      );
    });
  });

  describe("repeat the same migrate a project's node tree", () => {
    const mock = loadRecordedMock('migrate_nodes_commit_simple_repeat.json');

    it(`should return a node migration preview with no changes to perform`, (done) => {
      migratortronApi.post(
        'migrate/nodes/commit?simple&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(new Error(body.error.message));

          expect(jpath('existing.*.totalCount', body)).to.equal(
            jpath('nodes.*.totalCount', body)
          );
          expect(jpath('nodesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.nodesResult.errors).to.not.exist;
          expect(body?.nodesResult.created).to.equal(0);
          expect(body?.nodesResult.updated).to.equal(0);
          done();
        }
      );
    });
  });

  describe('preview migrating nodes supplied in the payload', () => {
    const mock = loadRecordedMock('migrate_nodes_import_preview.json');

    it(`should return a node migration preview`, (done) => {
      migratortronApi.post(
        'migrate/nodes?import',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(new Error(body.error.message));

          expect(body?.nodesToMigrate?.migratortron?.totalCount).to.equal(3);
          done();
        }
      );
    });
  });

  describe('migrate nodes supplied in the payload', () => {
    const mock = loadRecordedMock('migrate_nodes_commit_import.json');

    it(`should create the nodes and return the results`, (done) => {
      migratortronApi.post(
        'migrate/nodes/commit?import',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(new Error(body.error.message));

          expect(body?.nodesToMigrate?.migratortron?.totalCount).to.equal(3);
          expect(body?.nodesResult.errors).to.not.exist;
          expect(body?.nodesResult.created).to.equal(3);
          expect(body?.nodesResult.updated).to.equal(0);
          done();
        }
      );
    });
  });

  describe('repeat the same migrate nodes supplied in the payload', () => {
    const mock = loadRecordedMock('migrate_nodes_commit_import_repeat.json');

    it(`should return a node migration preview with no changes to perform`, (done) => {
      migratortronApi.post(
        'migrate/nodes/commit?import&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(new Error(body.error.message));

          expect(jpath('nodesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.nodesResult.errors).to.not.exist;
          expect(body?.nodesResult.created).to.equal(0);
          expect(body?.nodesResult.updated).to.equal(0);
          done();
        }
      );
    });
  });
});
